import { InfoCard } from '../../inform3d.content';
import './infoCards.css';

type InfoCardsProps = {
    cards: InfoCard[];
};

/**
 * The two-up card grid shared by "What We Take On" and "How We Do It".
 * Static by design - the choice between approaches is made in the form.
 */
function InfoCards({ cards }: InfoCardsProps) {
    return (
        <div className="inform__card-grid">
            {cards.map((card) => (
                <div key={card.title} className="inform__card">
                    <div className="inform__card-icon">
                        <card.icon className="sp-icon-md" />
                    </div>
                    <div className="inform__card-body">
                        <h3>{card.title}</h3>
                        <p>{card.description}</p>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default InfoCards;
